import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactExport from 'react-export-excel';
import { reduxForm } from "redux-form";
import { Container, Row, Col, } from 'reactstrap';
import Toaster from '../../common/Toaster';
import Drawer from '@material-ui/core/Drawer';
import { bulkUploadCosting } from '../../costing/actions/CostWorking'
import { ExcelRenderer } from 'react-excel-renderer';
import { getJsDateFromExcel } from "../../../helper/validation";
import DayTime from '../../common/DayTimeWrapper';
import imgCloud from '../../../assests/images/uploadcloud.png';
import _ from 'lodash'
import PopupMsgWrapper from '../../common/PopupMsgWrapper';

import { COMBINED_PROCESS, BOPDOMESTIC, BOPIMPORT, MACHINERATE, OPERATIONS, RMDOMESTIC, RMIMPORT, SURFACETREATMENT, RAWMATERIALINDEX } from '../../../config/constants';
import { bopFieldsToValidate, BoughtOutPartDomesticFileHeads, BoughtOutPartImportFileHeads, CombinedProcessFileHeads, machineFieldsToValidate, MachineRateFileHeads, OperationFileHeads, otherOperationFieldsToValidate, rawMaterialDomesticFieldsToValidate, RawMaterialDomesticFileHeads, rawMaterialImportFieldsToValidate, RawMaterialImportFileHeads } from '../../../config/masterData';
import TooltipCustom from '../../common/Tooltip';
import LoaderCustom from '../../common/LoaderCustom';
import { getConfigurationKey } from '../../../helper';
import { validateRevisedRate, validateRatesInBatch } from '../../common/CommonFunctions';

const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

// Master configuration for better maintainability
const MASTER_CONFIG = {
    [RMDOMESTIC]: {
        name: 'Raw Material Domestic',
        fileHeads: RawMaterialDomesticFileHeads,
        identifierField: 'RawMaterialCode',
        validateFields: rawMaterialDomesticFieldsToValidate,
        basicRateIndex: 'BasicRate',
        revisedRateIndex: 'RevisedBasicRate',
        scrapRateIndex: 'ScrapRate',
        revisedScrapIndex: 'RevisedScrapRate'
    },
    [RMIMPORT]: {
        name: 'Raw Material Import',
        fileHeads: RawMaterialImportFileHeads,
        identifierField: 'RawMaterialCode',
        validateFields: rawMaterialImportFieldsToValidate,
        basicRateIndex: 'BasicRate',
        revisedRateIndex: 'RevisedBasicRate',
        scrapRateIndex: 'ScrapRate',
        revisedScrapIndex: 'RevisedScrapRate'
    },
    [BOPDOMESTIC]: {
        name: 'Bought Out Part Domestic',
        fileHeads: BoughtOutPartDomesticFileHeads,
        identifierField: 'BoughtOutPartNumber',
        validateFields: bopFieldsToValidate,
        basicRateIndex: 'BasicRate',
        revisedRateIndex: 'RevisedBasicRate'
    },
    [BOPIMPORT]: {
        name: 'Bought Out Part Import',
        fileHeads: BoughtOutPartImportFileHeads,
        identifierField: 'BoughtOutPartNumber',
        validateFields: bopFieldsToValidate,
        basicRateIndex: 'BasicRate',
        revisedRateIndex: 'RevisedBasicRate'
    },
    [OPERATIONS]: {
        name: 'Operation',
        fileHeads: OperationFileHeads,
        identifierField: 'OperationCode',
        validateFields: otherOperationFieldsToValidate,
        basicRateIndex: 'Rate',
        revisedRateIndex: 'RevisedRate'
    },
    [SURFACETREATMENT]: {
        name: 'Surface Treatment',
        fileHeads: OperationFileHeads,
        identifierField: 'OperationCode',
        validateFields: otherOperationFieldsToValidate,
        basicRateIndex: 'Rate',  // Use same as Operations
        revisedRateIndex: 'RevisedRate'  // Use same as Operations
    },
    [MACHINERATE]: {
        name: 'Machine Rate',
        fileHeads: MachineRateFileHeads,
        identifierField: 'MachineNumber',
        validateFields: machineFieldsToValidate,
        basicRateIndex: 'MachineRate',
        revisedRateIndex: 'RevisedMachineRate'
    },
    [RAWMATERIALINDEX]: {
        name: 'Raw Material Indexation',
        fileHeads: RawMaterialDomesticFileHeads, // Using RM Domestic headers for now
        identifierField: 'RawMaterialCode',
        validateFields: rawMaterialDomesticFieldsToValidate, // Using RM Domestic validation
        basicRateIndex: 'BasicRate',
        revisedRateIndex: 'RevisedBasicRate',
        scrapRateIndex: 'ScrapRate',
        revisedScrapIndex: 'RevisedScrapRate'
    },
    [COMBINED_PROCESS]: {
        name: 'Combined Process',
        fileHeads: CombinedProcessFileHeads,
        identifierField: 'ProcessCode',
        basicRateIndex: 'CC',
        revisedRateIndex: 'RevisedCC'
    }
};

class SimulationUploadDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            fileData: '',
            fileName: '',
            correctRowCount: '',
            NoOfRowsWithoutChange: '',
            bulkUploadLoader: false,
            showConfirmationPopup: false,
            confirmationMessage: '',
            unchangedRecords: []
        }
    }

    // called every time a file's `status` changes
    handleChangeStatus = ({ meta, file }, status) => {

        const { files } = this.state

        if (status === 'removed') {
            const removedFileName = file.name
            let tempArr = files.filter(
                (item) => item.OriginalFileName !== removedFileName,
            )
            this.setState({ files: tempArr })
        }

        if (status === 'done') {
            this.setState({ fileName: file.name, fileData: file })
        }

        if (status === 'rejected_file_type') {
            Toaster.warning('Allowed only xlsx files.')
        }
    }

    // Helper function to get master configuration
    getMasterConfig = (masterValue) => {
        return MASTER_CONFIG[String(masterValue)] || {
            name: 'Master',
            identifierField: 'Code'
        };
    }

    // Generate confirmation message for unchanged records
    generateConfirmationMessage = (unchangedRecords, masterValue) => {
        const masterConfig = this.getMasterConfig(masterValue);

        if (unchangedRecords.length === 0) {
            return `This ${masterConfig.name} records basic rate not changed still you wish to continue?\nNote: If revised basic rate or scrap rate is not entered in the uploaded file, the existing basic rate and scrap rate will be used by default.`;
        }

        const recordNames = unchangedRecords.map(record => {
            const identifier = record[masterConfig.identifierField] || 'N/A';
            return `${identifier}`;
        }).join(', ');

        return `This ${masterConfig.name} ${unchangedRecords.length > 1 ? 'records' : 'record'} (${recordNames}) basic rate not changed still you wish to continue?\nNote: If revised basic rate or scrap rate is not entered in the uploaded file, the existing basic rate and scrap rate will be used by default.`;
    }

    // Utility functions for data processing
    normalize = (value) => {
        if (value === null || value === undefined || value === '-' || value === '') return '';
        return typeof value === 'number' ? String(value) : String(value).trim();
    }

    normalizeNum = (value) => {
        const n = Number(value);
        return isNaN(n) ? '' : String(n);
    }

    isNumeric = (val) => {
        if (val === null || val === undefined) return false;
        if (typeof val === 'number') return Number.isFinite(val);
        if (typeof val === 'string') {
            const s = val.trim();
            return s !== '' && /^\d+(\.\d+)?$/.test(s);
        }
        return false;
    }

    // Use common validation function for price validation
    validatePrice = (value, fieldName, rowNum = null) => {
        const result = validateRevisedRate(value, fieldName, rowNum);
        if (!result.isValid) {
            Toaster.warning(result.error);
        }
        return result;
    }

    formatDate = (dateVal) => {
        if (dateVal?.includes?.('T')) {
            return DayTime(dateVal).format('DD/MM/YYYY');
        }
        const regex = /^\d{4}-\d{2}-\d{2}$/;
        if (regex.test(dateVal)) {
            const [year, month, day] = dateVal.split("-");
            return `${day}/${month}/${year}`;
        }
        return dateVal;
    }

    // Check if value is empty or unchanged
    isEmptyOrUnchanged = (value, isUnchanged) => {
        // Consider empty if: isUnchanged flag is true, OR value is null/undefined/empty string
        // Note: 0 is considered a valid value (not empty)
        return isUnchanged || value === '' || value === null || value === undefined;
    }

    toggleDrawer = (event, isSaveButtonClicked) => {

        const { fileData, correctRowCount, NoOfRowsWithoutChange } = this.state
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.props.closeDrawer('', fileData, correctRowCount, NoOfRowsWithoutChange, isSaveButtonClicked)
    };

    cancel = () => {
        this.toggleDrawer('', true)
    }

    cancelWithoutData = () => {
        // Close drawer without passing data when validation fails
        this.props.closeDrawer('', [], 0, 0, false)
    }

    Preview = ({ meta }) => {
        return (
            <span
                style={{
                    alignSelf: 'flex-start',
                    margin: '10px 3%',
                    fontFamily: 'Helvetica',
                }}
            >
                {/* {Math.round(percent)}% */}
            </span>
        )
    }

    /**
    * @method returnExcelColumn
    * @description Used to get excel column names
    */
    returnExcelColumn = (data = [], TempData) => {
        const fileName = "Costing";
        return (
            <ExcelSheet data={TempData} name={fileName}>
                {data.map((ele, index) => (
                    <ExcelColumn key={index} label={ele.label} value={ele.label} />
                ))}
            </ExcelSheet>
        );
    }

    // Field mapping functions for Raw Material (Domestic & Import)
    mapRawMaterialFields = (obj, header, value, isUnchanged, fullRow, headers) => {
        const fieldMap = {
            'RevisedScrapRate': 'NewScrapRate',
            'Grade': 'RawMaterialGradeName',
            'Spec': 'RawMaterialSpecificationName',
            'Code': 'RawMaterialCode',
            'RawMaterial': 'RawMaterialName',
            'UOM': 'UnitOfMeasurementName',
            'Technology': 'TechnologyName',
            'BasicRate': 'BasicRatePerUOM',
            'RevisedBasicRate': 'NewBasicRate'
        };

        const mappedField = fieldMap[header] || header;

        // Handle RevisedBasicRate
        if (header === 'RevisedBasicRate') {
            // Treat 0 as empty for RevisedBasicRate (use BasicRate instead)
            if (this.isEmptyOrUnchanged(value, isUnchanged) || value === 0) {
                // If unchanged or no revised value provided, use the BasicRate
                const basicRateIndex = headers.indexOf('BasicRate');
                obj[mappedField] = basicRateIndex !== -1 ? fullRow[basicRateIndex] : '';
            } else {
                obj[mappedField] = value;
            }
        }
        // Handle RevisedScrapRate
        else if (header === 'RevisedScrapRate') {
            // Treat 0 as empty for RevisedScrapRate (use ScrapRate instead)
            if (this.isEmptyOrUnchanged(value, isUnchanged) || value === 0) {
                // If unchanged or no revised value provided, use the ScrapRate
                const scrapRateIndex = headers.indexOf('ScrapRate');
                obj[mappedField] = scrapRateIndex !== -1 ? fullRow[scrapRateIndex] : '';
            } else {
                obj[mappedField] = value;
            }
        }
        // Handle other fields normally
        else {
            obj[mappedField] = value;
        }
    }

    // Field mapping functions for Bought Out Part (Domestic & Import)
    mapBOPFields = (obj, header, value, isUnchanged, fullRow, headers) => {
        const fieldMap = {
            'RevisedBasicRate': 'NewBasicRate',
            'InsertPartNumber': 'BoughtOutPartNumber',
            'InsertPartName': 'BoughtOutPartName',
            'InsertPartCategory': 'BoughtOutPartCategory',
            'InsertPartId': 'BoughtOutPartId'
        };

        const mappedField = fieldMap[header] || header;

        // Handle RevisedBasicRate
        if (header === 'RevisedBasicRate') {
            // Treat 0 as empty for RevisedBasicRate (use BasicRate instead)
            if (this.isEmptyOrUnchanged(value, isUnchanged) || value === 0) {
                // If unchanged or no revised value provided, use the BasicRate
                const basicRateIndex = headers.indexOf('BasicRate');
                obj[mappedField] = basicRateIndex !== -1 ? fullRow[basicRateIndex] : '';
            } else {
                obj[mappedField] = value;
            }
        }
        // Handle other fields normally
        else {
            obj[mappedField] = value;
        }
    }

    // Field mapping functions for Operations & Surface Treatment
    mapOperationFields = (obj, header, value, isUnchanged, fullRow, headers) => {
        const fieldMap = {
            'RevisedRate': 'NewRate',
            'OperationType': 'ForType',
            'Consumption': 'OperationConsumption',
            'WeldingMaterialRate/kg': 'OperationBasicRate',
            'Revised WeldingMaterialRate/kg': 'NewOperationBasicRate'
        };

        const mappedField = fieldMap[header] || header;

        // Handle RevisedRate for Operations
        if (header === 'RevisedRate') {
            // Treat 0 as empty for RevisedRate (use Rate instead)
            if (this.isEmptyOrUnchanged(value, isUnchanged) || value === 0) {
                // If unchanged or no revised value provided, use the Rate
                const rateIndex = headers.indexOf('Rate');
                obj[mappedField] = rateIndex !== -1 ? fullRow[rateIndex] : '';
            } else {
                obj[mappedField] = value;
            }
        }
        // Handle Revised WeldingMaterialRate/kg for Surface Treatment
        else if (header === 'Revised WeldingMaterialRate/kg') {
            // Treat 0 as empty for Revised WeldingMaterialRate/kg (use WeldingMaterialRate/kg instead)
            if (this.isEmptyOrUnchanged(value, isUnchanged) || value === 0) {
                // If unchanged or no revised value provided, use the WeldingMaterialRate/kg
                const weldingRateIndex = headers.indexOf('WeldingMaterialRate/kg');
                obj[mappedField] = weldingRateIndex !== -1 ? fullRow[weldingRateIndex] : '';
            } else {
                obj[mappedField] = value;
            }
        }
        // Handle other fields normally
        else {
            obj[mappedField] = value;
        }
    }

    // Field mapping functions for Machine Rate
    mapMachineFields = (obj, header, value, isUnchanged, fullRow, headers) => {
        if (header === 'RevisedMachineRate') {
            // Treat 0 as empty for RevisedMachineRate (use MachineRate instead)
            if (this.isEmptyOrUnchanged(value, isUnchanged) || value === 0) {
                // If unchanged or no revised value provided, use the MachineRate
                const machineRateIndex = headers.indexOf('MachineRate');
                obj['NewMachineRate'] = machineRateIndex !== -1 ? fullRow[machineRateIndex] : '';
            } else {
                obj['NewMachineRate'] = value;
            }
        } else {
            obj[header] = value;
        }
    }

    // Field mapping functions for Combined Process
    mapCombinedProcessFields = (obj, header, value, isUnchanged, fullRow, headers) => {
        if (header === 'RevisedCC') {
            // Treat 0 as empty for RevisedCC (use CC instead)
            if (this.isEmptyOrUnchanged(value, isUnchanged) || value === 0) {
                // If unchanged or no revised value provided, use the CC
                const ccIndex = headers.indexOf('CC');
                obj['NewCC'] = ccIndex !== -1 ? fullRow[ccIndex] : '';
            } else {
                obj['NewCC'] = value;
            }
        } else {
            obj[header] = value;
        }
    }

    // Create record object based on master type
    createRecordObject = (row, headers, masterValue, isUnchanged = false) => {
        const obj = {};
        const masterNum = Number(masterValue);

        row.forEach((el, i) => {
            if (headers[i] === 'EffectiveDate' && typeof el === 'number') {
                el = getJsDateFromExcel(el);
            }

            // Map fields based on master type
            switch (masterNum) {
                case Number(RMDOMESTIC):
                case Number(RMIMPORT):
                    this.mapRawMaterialFields(obj, headers[i], el, isUnchanged, row, headers);
                    break;
                case Number(BOPDOMESTIC):
                case Number(BOPIMPORT):
                    this.mapBOPFields(obj, headers[i], el, isUnchanged, row, headers);
                    break;
                case Number(OPERATIONS):
                case Number(SURFACETREATMENT):
                    this.mapOperationFields(obj, headers[i], el, isUnchanged, row, headers);
                    break;
                case Number(MACHINERATE):
                    this.mapMachineFields(obj, headers[i], el, isUnchanged, row, headers);
                    break;
                case Number(COMBINED_PROCESS):
                    this.mapCombinedProcessFields(obj, headers[i], el, isUnchanged, row, headers);
                    break;
                default:
                    obj[headers[i]] = el;
            }
        });

        return obj;
    }

    // Process RM Indexation with validation
    processAndValidateRMIndexation = (rows, headerRow) => {
        // Normalize headers by removing spaces and converting to match expected format
        const normalizedHeaders = headerRow.map(h => String(h || '').replace(/\s+/g, ''));

        // Use indexOf to find column indices (same approach as RM Domestic)
        const masterConfig = this.getMasterConfig(RAWMATERIALINDEX);
        const basicRateIndex = normalizedHeaders.indexOf(masterConfig.basicRateIndex);
        const revisedBasicRateIndex = normalizedHeaders.indexOf(masterConfig.revisedRateIndex);
        const scrapRateIndex = normalizedHeaders.lastIndexOf(masterConfig.scrapRateIndex); // Use lastIndexOf for ScrapRate as it appears multiple times
        const revisedScrapRateIndex = normalizedHeaders.indexOf(masterConfig.revisedScrapIndex);
        const rawMaterialIdIndex = normalizedHeaders.indexOf('RawMaterialId');
        const codeIndex = normalizedHeaders.indexOf('Code');
        const rawMaterialNameIndex = headerRow.indexOf('RawMaterial'); // Updated to match new header format

        const list = this.props?.rmIndexationSimulationList || [];
        const tableById = new Map();
        list.forEach(record => {
            const id = record?.RawMaterialId ||
                      record?.OldRawMaterialIndexationDetails?.RawMaterialId ||
                      record?.NewRawMaterialIndexationDetails?.RawMaterialId;
            const key = String(id || '').trim();
            if (key) tableById.set(key, record);
        });

        const fileData = [];
        const unchangedRecords = [];
        let correctRowCount = 0;
        let NoOfRowsWithoutChange = 0;
        let scrapRateLessBasicRate = 0;
        const duplicateCount = new Map();

        // FIRST PASS: Validate all rows before processing (same as RM Domestic)
        const validationItems = [];
        for (let r = 1; r < rows.length; r++) {
            const row = rows[r];
            if (!row?.length) continue;

            const idKey = String(row[rawMaterialIdIndex] || '').trim();
            if (!idKey) {
                Toaster.warning(`Raw Material Id is required at row ${r + 1}.`);
                return { isValid: false };
            }

            const revisedBasicRate = revisedBasicRateIndex >= 0 ? row[revisedBasicRateIndex] : undefined;
            const revisedScrapRate = revisedScrapRateIndex >= 0 ? row[revisedScrapRateIndex] : undefined;
            const basicRate = basicRateIndex >= 0 ? row[basicRateIndex] : undefined;
            const scrapRate = scrapRateIndex >= 0 ? row[scrapRateIndex] : undefined;

            // Validate revised basic rate
            if (revisedBasicRate !== '' && revisedBasicRate !== null && revisedBasicRate !== undefined) {
                validationItems.push({
                    value: revisedBasicRate,
                    fieldName: 'Revised Basic Rate',
                    rowNum: r,
                    basicRate: basicRate,
                    revisedBasicRate: null
                });
            }

            // Validate revised scrap rate
            if (revisedScrapRate !== '' && revisedScrapRate !== null && revisedScrapRate !== undefined) {
                const revisedBasicRateValue = revisedBasicRate !== '' && revisedBasicRate !== null && revisedBasicRate !== undefined ? revisedBasicRate : null;

                validationItems.push({
                    value: revisedScrapRate,
                    fieldName: 'Revised Scrap Rate',
                    rowNum: r,
                    basicRate: basicRate,
                    revisedBasicRate: revisedBasicRateValue
                });
            }
        }

        // Validate all rates inline (same as RM Domestic)
        for (const item of validationItems) {
            const value = item.value;

            // Check if value is numeric and positive
            if (isNaN(value) || value === '' || value === null || value === undefined) {
                Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} must be a valid number.`);
                return {
                    isValid: false,
                    fileData: [],
                    correctRowCount: 0,
                    NoOfRowsWithoutChange: 0,
                    unchangedRecords: [],
                    scrapRateLessBasicRate: 0
                };
            }

            if (Number(value) < 0) {
                Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} cannot be negative.`);
                return {
                    isValid: false,
                    fileData: [],
                    correctRowCount: 0,
                    NoOfRowsWithoutChange: 0,
                    unchangedRecords: [],
                    scrapRateLessBasicRate: 0
                };
            }

            // For scrap rate, validate it's less than basic rate
            if (item.fieldName.includes('Scrap') && item.revisedBasicRate) {
                if (Number(value) > Number(item.revisedBasicRate)) {
                    Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} cannot be greater than Revised Basic Rate.`);
                    return {
                        isValid: false,
                        fileData: [],
                        correctRowCount: 0,
                        NoOfRowsWithoutChange: 0,
                        unchangedRecords: [],
                        scrapRateLessBasicRate: 0
                    };
                }
            } else if (item.fieldName.includes('Scrap') && item.basicRate) {
                if (Number(value) > Number(item.basicRate)) {
                    Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} cannot be greater than Basic Rate.`);
                    return {
                        isValid: false,
                        fileData: [],
                        correctRowCount: 0,
                        NoOfRowsWithoutChange: 0,
                        unchangedRecords: [],
                        scrapRateLessBasicRate: 0
                    };
                }
            }
        }

        // SECOND PASS: Process data only if validation passed (same as RM Domestic)
        for (let r = 1; r < rows.length; r++) {
            const row = rows[r];
            if (!row?.length) continue;

            const idKey = String(row[rawMaterialIdIndex] || '').trim();
            const existingRecord = tableById.get(idKey);

            const revisedBasicRate = revisedBasicRateIndex >= 0 ? row[revisedBasicRateIndex] : undefined;
            const revisedScrapRate = revisedScrapRateIndex >= 0 ? row[revisedScrapRateIndex] : undefined;
            const basicRate = basicRateIndex >= 0 ? row[basicRateIndex] : undefined;
            const scrapRate = scrapRateIndex >= 0 ? row[scrapRateIndex] : undefined;
            const rawMaterialCode = (codeIndex >= 0 ? row[codeIndex] : null) || idKey;
            const rawMaterialName = (rawMaterialNameIndex >= 0 ? row[rawMaterialNameIndex] : null) || 'N/A';

            // Check if no revised rate provided
            const hasRevisedBasicRate = !this.isEmptyOrUnchanged(revisedBasicRate, false);
            const hasRevisedScrapRate = !this.isEmptyOrUnchanged(revisedScrapRate, false);

            if (!hasRevisedBasicRate && !hasRevisedScrapRate) {
                NoOfRowsWithoutChange++;
                const unchangedRecord = {
                    RawMaterialId: idKey,
                    RawMaterialCode: rawMaterialCode,
                    RawMaterialName: rawMaterialName
                };
                unchangedRecords.push(unchangedRecord);

                fileData.push({
                    RawMaterialId: idKey,
                    NewBasicRatePerUOM: basicRate ? basicRate : existingRecord?.BasicRatePerUOM,
                    NewScrapRate: scrapRate ? scrapRate : existingRecord?.ScrapRate,
                    _noChanges: true
                });
                continue;
            }

            // Check scrap rate validation (same as RM Domestic)
            const finalScrapRate = hasRevisedScrapRate ? revisedScrapRate : scrapRate;
            const finalBasicRate = hasRevisedBasicRate ? revisedBasicRate : basicRate;
            if (Number(finalBasicRate) < Number(finalScrapRate)) {
                scrapRateLessBasicRate = 1;
            }

            correctRowCount++;
            fileData.push({
                RawMaterialId: idKey,
                NewBasicRatePerUOM: hasRevisedBasicRate ? revisedBasicRate : basicRate,
                NewScrapRate: hasRevisedScrapRate ? revisedScrapRate : scrapRate
            });
            duplicateCount.set(idKey, (duplicateCount.get(idKey) || 0) + 1);
        }

        const duplicates = [...duplicateCount.entries()]
            .filter(([, count]) => count > 1)
            .map(([key]) => key);

        if (duplicates.length) {
            Toaster.warning(`Duplicate entries found for Raw Material Id: ${duplicates.join(', ')}. Please remove duplicates.`);
            return { isValid: false };
        }

        return {
            isValid: true,
            fileData,
            basicRateCount: 1,
            correctRowCount,
            NoOfRowsWithoutChange,
            unchangedRecords,
            scrapRateLessBasicRate
        };
    };

    // Generic row processor for most master types
    processGenericRows = (rows, headerRow, masterValue) => {
        const masterConfig = this.getMasterConfig(masterValue);
        const br_index = headerRow.indexOf(masterConfig.basicRateIndex);
        const rbr_index = headerRow.indexOf(masterConfig.revisedRateIndex);

        let fileData = [];
        let correctRowCount = 0;
        let NoOfRowsWithoutChange = 0;
        let unchangedRecords = [];
        let scrapRateLessBasicRate = 0;

        // Handle scrap rates for RM types only
        let sr_index = -1;
        let rsr_index = -1
        // Only RM types have scrap rates
        if ([RMDOMESTIC, RMIMPORT].includes(String(masterValue))) {
            sr_index = headerRow.indexOf(masterConfig.scrapRateIndex);
            rsr_index = headerRow.indexOf(masterConfig.revisedScrapIndex);
        }

        // Collect all values to validate
        const validationItems = [];
        for (let i = 0; i < rows.length; i++) {
            const val = rows[i];
            if (val.length === 0 || i === 0) continue;

            // Add revised basic rate for validation only if the column exists
            if (rbr_index >= 0 && val[rbr_index] !== '' && val[rbr_index] !== null && val[rbr_index] !== undefined) {
                validationItems.push({
                    value: val[rbr_index],
                    fieldName: `${masterConfig.name} Revised Basic Rate`,
                    rowNum: i,
                    basicRate: val[br_index], // Pass basic rate for comparison
                    revisedBasicRate: null // Not needed for basic rate validation
                });
            }

            // Add revised scrap rate for validation (RM types only) - validate all rows
            if (rsr_index >= 0 && val[rsr_index] !== '' && val[rsr_index] !== null && val[rsr_index] !== undefined) {
                // For revised scrap rate, pass basic rate and revised basic rate for comparison
                const revisedBasicRateValue = val[rbr_index] !== '' && val[rbr_index] !== null && val[rbr_index] !== undefined ? val[rbr_index] : null;

                // Use basic rate from uploaded file
                let basicRateForComparison = val[br_index] !== '' && val[br_index] !== null && val[br_index] !== undefined ? val[br_index] : null;

                validationItems.push({
                    value: val[rsr_index],
                    fieldName: 'Revised Scrap Rate',
                    rowNum: i,
                    basicRate: basicRateForComparison,
                    revisedBasicRate: revisedBasicRateValue // Pass revised basic rate for comparison
                });
            }
        }

        // Validate all rates inline
        for (const item of validationItems) {
            const value = item.value;

            // Check if value is numeric and positive
            if (isNaN(value) || value === '' || value === null || value === undefined) {
                Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} must be a valid number.`);
                return {
                    fileData: [],
                    correctRowCount: 0,
                    NoOfRowsWithoutChange: 0,
                    unchangedRecords: [],
                    scrapRateLessBasicRate: 0,
                    hasValidationError: true
                };
            }

            if (Number(value) < 0) {
                Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} cannot be negative.`);
                return {
                    fileData: [],
                    correctRowCount: 0,
                    NoOfRowsWithoutChange: 0,
                    unchangedRecords: [],
                    scrapRateLessBasicRate: 0,
                    hasValidationError: true
                };
            }

            // For scrap rate, validate it's less than basic rate
            if (item.fieldName.includes('Scrap') && item.revisedBasicRate) {
                if (Number(value) > Number(item.revisedBasicRate)) {
                    Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} cannot be greater than Revised Basic Rate.`);
                    return {
                        fileData: [],
                        correctRowCount: 0,
                        NoOfRowsWithoutChange: 0,
                        unchangedRecords: [],
                        scrapRateLessBasicRate: 0,
                        hasValidationError: true
                    };
                }
            } else if (item.fieldName.includes('Scrap') && item.basicRate) {
                if (Number(value) > Number(item.basicRate)) {
                    Toaster.warning(`${item.fieldName} at row ${item.rowNum + 1} cannot be greater than Basic Rate.`);
                    return {
                        fileData: [],
                        correctRowCount: 0,
                        NoOfRowsWithoutChange: 0,
                        unchangedRecords: [],
                        scrapRateLessBasicRate: 0,
                        hasValidationError: true
                    };
                }
            }
        }

        // Second pass: process data only if validation passed
        for (let i = 0; i < rows.length; i++) {
            const val = rows[i];
            if (val.length === 0 || i === 0) continue;

            // Check if there's a rate change - only if revised rate column exists
            const hasRateChange = rbr_index >= 0 &&
                                  val[rbr_index] !== '' &&
                                  val[rbr_index] !== undefined &&
                                  val[rbr_index] !== null &&
                                  val[br_index] !== val[rbr_index];

            // Check scrap rate change for RM types
            let hasScrapRateChange = false;
            if (sr_index >= 0 && rsr_index >= 0) {
                hasScrapRateChange = val[rsr_index] !== '' &&
                                   val[rsr_index] !== undefined &&
                                   val[rsr_index] !== null &&
                                   val[sr_index] !== val[rsr_index];
            }

            // For RM types, consider both basic rate and scrap rate changes
            const isRMType = [RMDOMESTIC, RMIMPORT].includes(Number(masterValue));
            const hasAnyChange = isRMType ? (hasRateChange || hasScrapRateChange) : hasRateChange;

            if (!hasAnyChange) {
                NoOfRowsWithoutChange++;

                // Create unchanged record
                const unchangedObj = this.createRecordObject(val, headerRow, masterValue, true);

                // For RM types, enrich with OtherNetCost and NetConditionCost from original simulation data
                if (isRMType && this.props.tableData) {
                    const rawMaterialCode = unchangedObj.RawMaterialCode;
                    const matchingRecord = this.props.tableData.find(item => item.RawMaterialCode === rawMaterialCode);
                    if (matchingRecord) {
                        unchangedObj.OtherNetCost = matchingRecord.OtherNetCost || 0;
                        unchangedObj.NetConditionCost = matchingRecord.NetConditionCost || 0;
                        unchangedObj.RawMaterialOtherCostDetails = matchingRecord.RawMaterialOtherCostDetails || [];
                        unchangedObj.RawMaterialConditionsDetails = matchingRecord.RawMaterialConditionsDetails || [];
                    }
                }

                unchangedRecords.push(unchangedObj);

                // Add to fileData with _noChanges flag
                const fileDataObj = this.createRecordObject(val, headerRow, masterValue, false);
                fileDataObj._noChanges = true;

                // For RM types, enrich with OtherNetCost and NetConditionCost from original simulation data
                if (isRMType && this.props.tableData) {
                    const rawMaterialCode = fileDataObj.RawMaterialCode;
                    const matchingRecord = this.props.tableData.find(item => item.RawMaterialCode === rawMaterialCode);
                    if (matchingRecord) {
                        fileDataObj.OtherNetCost = matchingRecord.OtherNetCost || 0;
                        fileDataObj.NetConditionCost = matchingRecord.NetConditionCost || 0;
                        fileDataObj.RawMaterialOtherCostDetails = matchingRecord.RawMaterialOtherCostDetails || [];
                        fileDataObj.RawMaterialConditionsDetails = matchingRecord.RawMaterialConditionsDetails || [];
                    }
                }

                fileData.push(fileDataObj);
                continue;
            }

            // Check scrap rate validation for RM types
            if (sr_index >= 0 && rsr_index >= 0) {
                const scrapTemp = (val[rsr_index] !== val[sr_index]) && val[rsr_index] ? val[rsr_index] : val[sr_index];
                const basicTemp = (val[rbr_index] !== val[br_index]) && val[rbr_index] ? val[rbr_index] : val[br_index];
                if (basicTemp < scrapTemp) {
                    scrapRateLessBasicRate = 1;
                }
            }

            correctRowCount++;
            const obj = this.createRecordObject(val, headerRow, masterValue, false);

            // For RM types, enrich with OtherNetCost and NetConditionCost from original simulation data
            if (isRMType && this.props.tableData) {
                const rawMaterialCode = obj.RawMaterialCode;
                const matchingRecord = this.props.tableData.find(item => item.RawMaterialCode === rawMaterialCode);
                if (matchingRecord) {
                    obj.OtherNetCost = matchingRecord.OtherNetCost || 0;
                    obj.NetConditionCost = matchingRecord.NetConditionCost || 0;
                    obj.RawMaterialOtherCostDetails = matchingRecord.RawMaterialOtherCostDetails || [];
                    obj.RawMaterialConditionsDetails = matchingRecord.RawMaterialConditionsDetails || [];
                }
            }

            fileData.push(obj);
        }

        return {
            fileData,
            correctRowCount,
            NoOfRowsWithoutChange,
            unchangedRecords,
            scrapRateLessBasicRate
        };
    }

    // File handler method
    fileHandler = event => {
        this.setState({
            bulkUploadLoader: true,
            unchangedRecords: []
        });

        const fileObj = event.target.files[0];
        const inputEl = event.target;
        let hasError = false;

        if (!fileObj) {
            this.setState({ bulkUploadLoader: false });
            return;
        }

        const uploadfileName = fileObj.name;
        const fileType = uploadfileName.substr(uploadfileName.indexOf('.'));

        if (fileType !== '.xls' && fileType !== '.xlsx') {
            Toaster.warning('File type should be .xls or .xlsx');
            if (inputEl) inputEl.value = '';
            this.setState({ bulkUploadLoader: false });
            return;
        }

        this.setState({ bulkUploadLoader: false });

        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                return;
            }

            const fileHeads = resp.rows[0];
            const masterConfig = this.getMasterConfig(this.props.master.value);

            // Validate file headers
            const headersToCheck = masterConfig.fileHeads?.slice(0,
                [RMDOMESTIC, RMIMPORT, RAWMATERIALINDEX].includes(Number(this.props.master.value)) ? 7 :
                [COMBINED_PROCESS].includes(Number(this.props.master.value)) ? 5 : 4
            );

            if (headersToCheck && !_.isEqual(fileHeads.slice(0, headersToCheck.length), headersToCheck)) {
                Toaster.warning('Please select file of same Master');
                return;
            }

            let result;

            // Process based on master type
            if (Number(this.props.master.value) === Number(RAWMATERIALINDEX)) {
                result = this.processAndValidateRMIndexation(resp.rows, resp.rows[0]);
                if (!result?.isValid) {
                    hasError = true;
                }
            } else {
                result = this.processGenericRows(resp.rows, resp.rows[0], this.props.master.value);

                // Check if validation error occurred
                if (result.hasValidationError) {
                    hasError = true;
                }
            }

            // Check scrap rate validation for RM types (applies to both RM Indexation and RM Domestic/Import)
            if (result.scrapRateLessBasicRate === 1) {
                Toaster.warning('Scrap Rate should be less than Basic Rate.');
                hasError = true;
            }

            if (hasError) {
                if (inputEl) inputEl.value = '';
                this.setState({
                    fileData: [],
                    uploadfileName: '',
                    correctRowCount: 0,
                    NoOfRowsWithoutChange: 0,
                    unchangedRecords: []
                });
                return;
            }

            // Perform validations
            if (result.fileData.length > 0) {
                if (!this.validateAgainstExistingData(result.fileData, this.props.master.value) ||
                    !this.validateConsistentRates(result.fileData, this.props.master.value)) {
                    if (inputEl) inputEl.value = '';
                    this.setState({
                        fileData: [],
                        uploadfileName: '',
                        correctRowCount: 0,
                        NoOfRowsWithoutChange: 0,
                        unchangedRecords: []
                    });
                    return;
                }
            }

            this.setState({
                fileData: result.fileData,
                uploadfileName: uploadfileName,
                correctRowCount: result.correctRowCount,
                NoOfRowsWithoutChange: result.NoOfRowsWithoutChange,
                unchangedRecords: result.unchangedRecords
            });
        });
    }

    // Check master type and return fields to validate
    checkMaster = (masterType) => {
        const type = Number(masterType);
        if (type === Number(MACHINERATE)) return machineFieldsToValidate;
        if (type === Number(BOPDOMESTIC) || type === Number(BOPIMPORT)) return bopFieldsToValidate;
        if (type === Number(RMDOMESTIC)) return rawMaterialDomesticFieldsToValidate;
        if (type === Number(RMIMPORT)) return rawMaterialImportFieldsToValidate;
        if (type === Number(OPERATIONS) || type === Number(SURFACETREATMENT)) return otherOperationFieldsToValidate;

        return [];
    }

    // File validation methods
    getValidationConfig = (masterType) => {
        const masterNum = Number(masterType);
        const configs = {
            [Number(MACHINERATE)]: {
                findMatchingRecord: (record, row) => record?.MachineNumber === row?.MachineNumber && record?.MachineProcessRateId === row?.MachineProcessRateId,
                getRecordNotFoundMessage: row => `Machine ${row?.MachineNumber}, Process ${row?.ProcessName} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (Machine ${row?.MachineNumber}, Process ${row?.ProcessName}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(BOPDOMESTIC)]: {
                findMatchingRecord: (record, row) => record?.BoughtOutPartId === row?.BoughtOutPartId,
                getRecordNotFoundMessage: row => `Bought Out Part ${row?.BoughtOutPartNumber} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (BOP ${row?.BoughtOutPartNumber}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(BOPIMPORT)]: {
                findMatchingRecord: (record, row) => record?.BoughtOutPartId === row?.BoughtOutPartId,
                getRecordNotFoundMessage: row => `Bought Out Part ${row?.BoughtOutPartNumber} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (BOP ${row?.BoughtOutPartNumber}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(RMDOMESTIC)]: {
                findMatchingRecord: (record, row) => record?.RawMaterialId === row?.RawMaterialId,
                getRecordNotFoundMessage: row => `Raw Material ${row?.RawMaterialCode} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (Raw Material ${row?.RawMaterialCode}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(RMIMPORT)]: {
                findMatchingRecord: (record, row) => record?.RawMaterialId === row?.RawMaterialId,
                getRecordNotFoundMessage: row => `Raw Material ${row?.RawMaterialCode} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (Raw Material ${row?.RawMaterialCode}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(OPERATIONS)]: {
                findMatchingRecord: (record, row) => record?.OperationId === row?.OperationId,
                getRecordNotFoundMessage: row => `Operation ${row?.OperationCode} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (Operation ${row?.OperationCode}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(SURFACETREATMENT)]: {
                findMatchingRecord: (record, row) => record?.OperationId === row?.OperationId,
                getRecordNotFoundMessage: row => `Surface Treatment ${row?.OperationCode} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (Surface Treatment ${row?.OperationCode}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(RAWMATERIALINDEX)]: {
                findMatchingRecord: (record, row) => {
                    const recordId = record?.RawMaterialId || record?.OldRawMaterialIndexationDetails?.RawMaterialId || record?.NewRawMaterialIndexationDetails?.RawMaterialId;
                    return String(recordId || '').trim() === String(row?.RawMaterialId || '').trim();
                },
                getRecordNotFoundMessage: row => `Raw Material ${row?.RawMaterialCode || row?.RawMaterialId} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `${field.message} mismatch (Raw Material ${row?.RawMaterialCode || row?.RawMaterialId}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            },
            [Number(COMBINED_PROCESS)]: {
                findMatchingRecord: (record, row) => record?.ProcessCode === row?.ProcessCode,
                getRecordNotFoundMessage: row => `Combined Process ${row?.ProcessCode} not found.`,
                getFieldMismatchMessage: (field, row, existingValue, uploadValue) =>
                    `Combined Process mismatch (Process ${row?.ProcessCode}): Expected '${existingValue}', Found '${uploadValue?.trim() === '' ? 'no data' : uploadValue}'`
            }
        };

        return configs[masterNum] || {
            findMatchingRecord: () => false,
            getRecordNotFoundMessage: () => 'Record not found',
            getFieldMismatchMessage: () => 'Field mismatch'
        };
    }

    validateAgainstExistingData = (fileData, masterType) => {
        const { tableData } = this.props;

        if (!tableData?.length) return true;

        const validTypes = [Number(MACHINERATE), Number(BOPDOMESTIC), Number(BOPIMPORT), Number(RMDOMESTIC), Number(RMIMPORT), Number(OPERATIONS), Number(SURFACETREATMENT)];
        if (!validTypes.includes(Number(masterType))) return true;

        const allFieldsToValidate = this.checkMaster(masterType);
        // Filter out RevisedBasicRate and RevisedScrapRate fields
        // For Surface Treatment, also filter out Operation Type field since it doesn't exist in surface treatment files
        const fieldsToValidate = allFieldsToValidate.filter(field =>
            field.upload !== 'NewBasicRate' &&
            field.upload !== 'NewScrapRate' &&
            field.message !== 'Revised Basic Rate' &&
            field.message !== 'Revised Scrap Rate' &&
            !(Number(masterType) === Number(SURFACETREATMENT) && field.upload === 'ForType')
        );

        const config = this.getValidationConfig(masterType);

        for (let i = 0; i < fileData.length; i++) {
            const uploadedRow = fileData[i];

            const existingRecord = tableData.find(record => config.findMatchingRecord(record, uploadedRow));

            if (!existingRecord) {
                Toaster.warning(config.getRecordNotFoundMessage(uploadedRow));
                return false;
            }

            for (const field of fieldsToValidate) {
                let uploadValue = (uploadedRow[field.upload] ?? '').toString().trim();
                let existingValue = (existingRecord[field.existing] ?? '').toString().trim();

                if (field.upload === 'EffectiveDate' && existingValue) {
                    uploadValue = this.formatDate(uploadValue?.split(" ")[0]);
                    existingValue = (existingRecord?.EffectiveDate)?.includes("T") ? DayTime(existingRecord?.EffectiveDate).format("DD/MM/YYYY") : existingRecord?.EffectiveDate;
                }

                // Check for exact match or special cases where one is "-" and other is empty
                const isExactMatch = uploadValue === existingValue;
                const isSpecialCase = (uploadValue === '-' && existingValue === '') ||
                                     (uploadValue === '' && existingValue === '-');
                const isMatch = isExactMatch || isSpecialCase;

                if (!isMatch) {
                    Toaster.warning(config.getFieldMismatchMessage(field, uploadedRow, existingValue, uploadValue));
                    return false;
                }
            }
        }

        return true;
    }

    validateConsistentRates = (fileData, masterType) => {
        const rateMap = new Map();
        const duplicateMap = new Map();
        const changedRatesMap = new Map(); // Track which machine numbers have changed rates

        const validationRules = {
            [Number(MACHINERATE)]: {
                keyField: row => `${row?.MachineNumber}_${row?.MachineProcessRateId}`,
                consistencyKey: row => row?.MachineNumber?.trim(),
                rateField: 'NewMachineRate',
                oldRateField: 'MachineRate', // Add field to check original rate
                itemType: "Machine Number and Process",
                checkConsistency: true
            },
            [Number(RMDOMESTIC)]: {
                keyField: row => `${row?.RawMaterialId}`,
                rateField: 'NewBasicRate',
                itemType: "Raw Material Code"
            },
            [Number(RMIMPORT)]: {
                keyField: row => `${row?.RawMaterialId}`,
                rateField: 'NewBasicRate',
                itemType: "Raw Material Code"
            },
            [Number(RAWMATERIALINDEX)]: {
                keyField: row => `${row?.RawMaterialId}`,
                rateField: 'NewBasicRate',
                itemType: "Raw Material Code"
            },
            [Number(BOPDOMESTIC)]: {
                keyField: row => `${row?.BoughtOutPartId}`,
                rateField: 'NewBasicRate',
                itemType: "Bought Out Part Number"
            },
            [Number(BOPIMPORT)]: {
                keyField: row => `${row?.BoughtOutPartId}`,
                rateField: 'NewBasicRate',
                itemType: "Bought Out Part Number"
            },
            [Number(OPERATIONS)]: {
                keyField: row => `${row?.OperationId}`,
                rateField: 'NewRate',
                itemType: "Operation Code"
            },
            [Number(SURFACETREATMENT)]: {
                keyField: row => `${row?.OperationId}`,
                rateField: 'NewRate',
                itemType: "Operation Code"
            },
            [Number(COMBINED_PROCESS)]: {
                keyField: row => `${row?.ProcessCode}`,
                rateField: 'NewCC',
                itemType: "Process Code"
            }
        };

        const rules = validationRules[Number(masterType)];
        if (!rules) return true;

        // For machine rate consistency check, track which machines have user-entered rates
        const machineUserEnteredRates = new Map(); // Map<machineNumber, Set<rate>>
        const machineHasChanges = new Map(); // Map<machineNumber, boolean>

        for (const row of fileData) {
            const key = rules.keyField(row);
            const newRate = Number(row[rules.rateField]);

            // Check for duplicates
            duplicateMap.set(key, (duplicateMap.get(key) || 0) + 1);

            // Check for inconsistent rates (only for MACHINERATE with IsMachineProcessGroup)
            if (rules.checkConsistency && rules.consistencyKey && newRate !== undefined && newRate !== null && newRate !== '' && newRate !== 'NaN' && getConfigurationKey()?.IsMachineProcessGroup) {
                const consistencyKey = rules.consistencyKey(row);

                // Track if this machine has any user-entered changes
                if (!row._noChanges) {
                    machineHasChanges.set(consistencyKey, true);

                    // Track user-entered rates for this machine
                    if (!machineUserEnteredRates.has(consistencyKey)) {
                        machineUserEnteredRates.set(consistencyKey, new Set());
                    }
                    machineUserEnteredRates.get(consistencyKey).add(newRate);
                }
            }
        }

        // Validate that all user-entered rates for the same machine are consistent
        if (rules.checkConsistency && getConfigurationKey()?.IsMachineProcessGroup) {
            for (const [machineNumber, rates] of machineUserEnteredRates.entries()) {
                if (rates.size > 1) {
                    Toaster.warning(`Inconsistent revised rates found for same Machine Number (${machineNumber}). All revised rates should be same even for different Process.`);
                    return false;
                }
            }

            // Check if user entered rate for some processes but not all for the same machine
            for (const row of fileData) {
                if (rules.consistencyKey) {
                    const consistencyKey = rules.consistencyKey(row);

                    // If this machine has some user-entered changes, all records must have changes
                    if (machineHasChanges.get(consistencyKey) && row._noChanges) {
                        Toaster.warning(`Inconsistent revised rates found for same Machine Number (${consistencyKey}). All revised rates should be same even for different Process. Please enter revised rate for all processes of the same machine.`);
                        return false;
                    }
                }
            }
        }

        const duplicates = [...duplicateMap.entries()]
            .filter(([, count]) => count > 1)
            .map(([key]) => key);

        if (duplicates.length > 0) {
            const uniqueDuplicates = [...new Set(duplicates)];
            Toaster.warning(`Duplicate entries found for ${rules.itemType}: ${uniqueDuplicates.join(', ')}. Please remove duplicates.`);
            return false;
        }

        return true;
    }

    // Component methods (toggleDrawer, cancel, onSubmit, etc.)
    toggleDrawer = (event, isSaveButtonClicked) => {
        const { fileData, correctRowCount, NoOfRowsWithoutChange, unchangedRecords } = this.state;

        if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        const isRequestBulkUploadForRMIndexation = String(this.props?.master?.value) === RAWMATERIALINDEX? true : false;

        let dataToSend = [...fileData];

        if (dataToSend.length === 0 && NoOfRowsWithoutChange > 0) {
            if (isRequestBulkUploadForRMIndexation) {
                dataToSend = unchangedRecords.map(record => ({
                    RawMaterialId: record.RawMaterialId,
                    NewBasicRatePerUOM: record.BasicRate,
                    NewScrapRate: record.ScrapRate,
                    _noChanges: true
                }));
            } else {
                dataToSend = [...unchangedRecords];
            }
        }

        this.props.closeDrawer('', dataToSend, correctRowCount, NoOfRowsWithoutChange, isSaveButtonClicked, isRequestBulkUploadForRMIndexation);
    };

    cancel = () => {
        const mockEvent = { type: 'button' };
        this.toggleDrawer(mockEvent, true);
    }

    onSubmit = () => {
        const { fileData, unchangedRecords, NoOfRowsWithoutChange } = this.state;

        if (fileData.length === 0 && NoOfRowsWithoutChange === 0) {
            Toaster.warning("Please select a file to upload.");
            return false;
        }

        if ((unchangedRecords?.length > 0) || (NoOfRowsWithoutChange > 0 && fileData.length === 0)) {
            const confirmationMessage = this.generateConfirmationMessage(unchangedRecords, this.props.master.value);
            this.setState({
                showConfirmationPopup: true,
                confirmationMessage: confirmationMessage
            });
        } else {
            this.cancel();
        }
    }

    // Popup handlers
    closeConfirmationPopup = () => {
        this.setState({
            showConfirmationPopup: false,
            confirmationMessage: ''
        });
    }

    onConfirmationConfirm = (e) => {
        if (e?.preventDefault) e.preventDefault();

        this.setState({ showConfirmationPopup: false }, () => {
            setTimeout(() => this.processFileUpload(), 100);
        });
    }

    processFileUpload = () => {
        const { fileData, NoOfRowsWithoutChange } = this.state;

        if (fileData.length === 0 && NoOfRowsWithoutChange === 0) {
            Toaster.warning("Please select a file to upload.");
            return false;
        }

        this.cancel();
    }

    Preview = ({ meta }) => (
        <span style={{
            alignSelf: 'flex-start',
            margin: '10px 3%',
            fontFamily: 'Helvetica',
        }} />
    )

    render() {
        const { handleSubmit } = this.props;

        return (
            <>
                <Drawer
                    anchor={this.props.anchor}
                    open={this.props.isOpen}
                >
                    <Container>
                        <div className="drawer-wrapper">
                            <form
                                noValidate
                                className="form"
                                onSubmit={handleSubmit(this.onSubmit.bind(this))}
                            >
                                <Row className="drawer-heading">
                                    <Col>
                                        <div className="header-wrapper left">
                                            <h3>Upload Data</h3>
                                        </div>
                                        <div
                                            onClick={(e) => this.toggleDrawer(e, false)}
                                            className="close-button right"
                                        />
                                    </Col>
                                </Row>
                                <Row className="pl-3">
                                    <Col md="12">
                                        <label className="d-inline-block w-auto">Upload</label>
                                        <TooltipCustom
                                            placement="left"
                                            customClass="mt-1"
                                            tooltipClass="right-tooltip"
                                            id="upload-icon"
                                            tooltipText="Please upload the file with data. The file can be downloaded from previous screen."
                                        />
                                        <div className="input-group mt-1 input-withouticon">
                                            {this.state.bulkUploadLoader && <LoaderCustom customClass="attachment-loader" />}
                                            <div className="file-uploadsection">
                                                <label>
                                                    Drag a file here or<span className="blue-text">Browse</span> for a file to upload
                                                    <img alt="" src={imgCloud} />
                                                </label>
                                                <input
                                                    type="file"
                                                    name="File"
                                                    onClick={(event) => { event.target.value = []; }}
                                                    onChange={this.fileHandler}
                                                    className=""
                                                    placeholder="Upload file"
                                                />
                                                <p>{this.state.uploadfileName}</p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="sf-btn-footer no-gutters justify-content-between">
                                    <div className="col-md-12 pl-3 pr-3">
                                        <div className="text-right">
                                            <button type="submit" className="btn-primary save-btn">
                                                <div className="save-icon" />
                                                SAVE
                                            </button>
                                        </div>
                                    </div>
                                </Row>
                            </form>
                        </div>
                    </Container>
                </Drawer>
                <PopupMsgWrapper
                    isOpen={this.state.showConfirmationPopup}
                    closePopUp={this.closeConfirmationPopup}
                    confirmPopup={(e) => this.onConfirmationConfirm(e)}
                    message={this.state.confirmationMessage}
                    firstButtonName="OK"
                    secondButtonName="Cancel"
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    // Return state mapping here
}

export default connect(mapStateToProps, {
    bulkUploadCosting
})(reduxForm({
    form: 'SimulationUploadDrawer',
    enableReinitialize: true,
    touchOnChange: true
})(SimulationUploadDrawer));
